export enum LocationHolderType {
  Agent = "Agent",
  LogisticsVehicle = "LogisticsVehicle",
  Device = "Device"
}
